/* eslint-disable prettier/prettier */
import { compose } from "./fn";

export const map = mapper => reducer => (accumulator, item, index, arr) =>
	reducer(accumulator, mapper(item, index, arr), index, arr);

export const filter = predicate => reducer => (accumulator, item, index, arr) =>
	predicate(item, index, arr)
		? reducer(accumulator, item, index, arr)
		: accumulator;

export const push = (list, item) => {
	list.push(item);
	return list;
};

export const transduce = (list, reducer, initialValue, ...transducers) =>
	list.reduce(compose(...transducers)(reducer), initialValue);
